import { useState, useEffect } from "react";

const descriptions = [
  "Practice typing without distractions",
  "Just you, the keyboard, and the words",
  "Train your fingers. Clear your mind",
];

const Hero = () => {
  const [displayText, setDisplayText] = useState("");
  const [descIndex, setDescIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (charIndex < descriptions[descIndex].length) {
      const timeout = setTimeout(() => {
        setDisplayText((prev) => prev + descriptions[descIndex][charIndex]);
        setCharIndex((prev) => prev + 1);
      }, 50); // typing speed
      return () => clearTimeout(timeout);
    } else {
      // After full line typed, wait then move to next
      const timeout = setTimeout(() => {
        setDisplayText("");
        setCharIndex(0);
        setDescIndex((prev) => (prev + 1) % descriptions.length);
      }, 2000); // wait 2s before next line
      return () => clearTimeout(timeout);
    }
  }, [charIndex, descIndex]);

  return (
    <div className="p-3 flex flex-col">
      <div className="text-center mb-5">
        <span className="font-caveat bg-gradient-to-r from-yellow-500 via-red-500 to-pink-500 text-transparent bg-clip-text text-3xl md:text-5xl lg:text-7xl">
          {/* {displayText} */}
          <span className="leading-none">Practice typing without distractions</span>
          {/* <span className="animate-pulse text-gray-900 dark:text-gray-200 text-4xl md:text-5xl lg:text-7xl">_</span> */}
        </span>

        <p className="mt-4 text-gray-800 dark:text-gray-300 text-sm sm:text-sm md:text-base lg:text-lg max-w-3xl mx-auto">
          Improve your typing speed and accuracy with a minimal, focused
          environment. Track your progress, challenge yourself, and build the
          confidence to type faster every day.
        </p>

      </div>
    </div>
  );
};

export default Hero;
